module.exports = __webpack_public_path__ + "static/media/parkeringsplass.d8741135.svg";